export default __webpack_public_path__ + "static/media/james_prado_roberts_head.86364e6c.jpg";